import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { HttpLoadingIndicatorService } from '../services/http-loading-indicator.service';

@Injectable()
// Intercepts the http call to add authorization token
export class AppHttpInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(private loadingService: HttpLoadingIndicatorService) {}

  removeRequest(req: HttpRequest<any>) {
    const index = this.requests.indexOf(req);
    if (index >= 0) {
      this.requests.splice(index, 1);
    }
    if (!this.requests.length) this.loadingService.setLoading(false);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipSpinner = req.headers.has('Skip-Spinner');
    if (!skipSpinner) {
      this.requests.push(req);
      this.loadingService.setLoading(true);
    }
    const currentCulture = localStorage.getItem('culture');
    const mustSkip = req.headers.has('Skip-Interceptor');
    const noAuth = req.headers.has('Skip-Authorization');
    const apiKey = localStorage.getItem('apiKey');
    const token = localStorage.getItem('token');
    if (!apiKey) {
      return next.handle(req).pipe(
        finalize(() => {
          this.removeRequest(req);
        })
      );
    }
    let headers = new HttpHeaders()
      .append('X-Frame-Options', 'deny')
      .append('ApiKey', apiKey)
      .append('Authorization', 'Bearer ' + token)
      .append('Content-Type', 'application/json')
      .append('Access-Control-Allow-Origin', '*')
      .append('Accept-Language', !currentCulture ? 'en-CA' : currentCulture);
    if (mustSkip || !req.url.includes('http')) {
      headers = headers.delete('Content-Type');
    } else if (noAuth) {
      headers = headers.delete('Authorization');
    }

    if (skipSpinner) {
      headers = headers.delete('Skip-Spinner');
    }
    const copiedRequest = req.clone({ headers: headers });
    return next.handle(copiedRequest).pipe(
      finalize(() => {
        if (!skipSpinner) {
          this.removeRequest(req);
        }
      })
    );
  }
}
